// extracted by mini-css-extract-plugin
export var modal = "_gs-0";